var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.75 7.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0b5ed6;\n        stroke-miterlimit: 10;\n        stroke-width: .3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "I4KsKu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.57.23c-.12-.13-.31-.11-.41.03L.18,7.15c-.09.18.02.38.22.39,2.67,0,5.35.01,8.02,0,.2-.08.23-.25.13-.43-.28-.52-.61-1.05-.91-1.56-.93-1.6-1.85-3.22-2.78-4.83-.07-.12-.21-.4-.29-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.68,5.58c-.14.19-.52.18-.64-.03-.06-.11-.04-.35-.05-.47-.05-.89-.1-1.79-.14-2.68,0-.19-.05-.33.08-.5.17-.23.66-.22.85-.02.16.18.1.31.09.53-.04.9-.09,1.8-.14,2.69,0,.14.02.37-.07.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4.38,
    cy: 6.44,
    r: 0.44
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/Icon 11.3de5b47670b108d76ecd84d8b401a06d.svg";
export { ForwardRef as ReactComponent };